var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLa(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 86,
    viewBox: "0 0 90 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.01921 69.2543L4.46153 72.235L11.0811 70.6481L31.687 75.2818L37.5467 74.2863L34.0156 67.6024L41.2039 69.2543L46.3745 72.235L48.8967 78.7002L56.085 72.235L51.6711 82.3574L54.8239 83.7446L57.3461 78.7002L59.49 81.0963L58.2289 83.7446L64.1561 85.0058L65.165 78.7002L70.0833 82.3574L71.8489 85.0058L72.9839 77.9435L71.8489 74.2863L84.2078 79.7091V83.7446L89 81.0963L85.4689 78.7002L81.3072 72.235L85.4689 69.2543L84.2078 64.7019L81.3072 69.2543L78.0283 65.5847L80.2983 61.9274L78.0283 60.4141L81.3072 59.2791L77.0194 51.3341L79.5417 44.5241H45.4917L44.1045 38.2186L47.8878 35.9486L48.8967 29.1386L54.8239 22.9084L53.5628 18.4191L58.2289 16.1491L54.8239 12.1136V8.33024L53.5628 5.17747L54.8239 2.90747L52.9748 1.3624L1.04831 1L1 22.9084L3.49998 25.3123L10.3269 43.389L6.9615 54.0621L6.86534 63.9658L3.01921 69.2543Z",
    fill: "#273137",
    fillOpacity: 0.1,
    stroke: "#273137",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLa);
export default __webpack_public_path__ + "static/media/LA.c0dc9358b0b9d7928cb8e7425be55b54.svg";
export { ForwardRef as ReactComponent };